type TypewriterOptions = {
  iterations: number;
  pause: number;
  speed: number;
  words: string[];
};

export class Typewriter {
  private element: HTMLElement;
  private iterations: number;
  private pause: number;
  private speed: number;
  private words: string[];
  private charCounter: number = 0;
  private iterationCounter: number = 0;
  private wordIndex: number = 0;

  constructor(element: HTMLElement, options: TypewriterOptions) {
    const { iterations, pause, speed, words } = options;

    this.element = element;
    this.iterations = iterations; // -1 for infinite
    this.pause = pause;
    this.speed = speed;
    this.words = words;
  }

  run(): void {
    setTimeout(() => this.type(), this.pause);
  }

  private getRandomizedSpeed(): number {
    return Math.floor(Math.random() * 50 + 1) + this.speed;
  }

  private type(): void {
    const currentWord = this.words[this.wordIndex];

    if (this.charCounter < currentWord.length) {
      const currentText = this.element.textContent || "";
      this.element.textContent = currentText + currentWord.charAt(this.charCounter);
      this.charCounter++;
      setTimeout(() => this.type(), this.getRandomizedSpeed());
    } else if (this.shouldContinueTyping()) {
      setTimeout(() => this.untype(), this.pause);
    }
  }

  private untype(): void {
    if (this.charCounter > 0) {
      const currentWord = this.words[this.wordIndex];
      this.element.textContent = currentWord.substring(0, this.charCounter - 1);
      this.charCounter--;
      setTimeout(() => this.untype(), this.getRandomizedSpeed());
    } else if (this.wordIndex + 1 < this.words.length) {
      this.wordIndex++;
      setTimeout(() => this.type(), this.pause);
    } else if (this.shouldStartNewIteration()) {
      this.iterationCounter++;
      this.wordIndex = 0;
      setTimeout(() => this.type(), this.pause);
    }
  }

  private shouldContinueTyping(): boolean {
    return this.wordIndex + 1 < this.words.length ||
           this.shouldStartNewIteration();
  }

  private shouldStartNewIteration(): boolean {
    return this.iterationCounter + 1 < this.iterations || this.iterations === -1;
  }
}
